import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import {
  CartTooltipTitle, CartItemContainer, CartItemImage,
  CartItemDetails, CartItemTitle, CartItemAuthor, 
  CartItemButton, CartEmptyText, CartTooltipTitleBox
} from './styles';
import { CONFIG } from '../../utils/config';
import { SdfBusyIndicator } from '@waypoint/react-components';
import { useTranslatedObject } from '../../utils/translation';

const CartItem = ({ item, onClick, header, cart }) => (
  <CartItemContainer onClick={onClick} className='cursor-pointer'>
    <CartItemImage src={item.image} alt={item.title} />
    <CartItemDetails>
      <CartItemTitle>{item.title}</CartItemTitle>
      <CartItemAuthor>{item.author && `${header.by_company} ${item.author}`}</CartItemAuthor>
      <CartItemAuthor>{item.edition && `${cart.edition} ${item.edition}`}</CartItemAuthor>
    </CartItemDetails>
  </CartItemContainer>
);

const CartTooltipContent = ({ cartData, isLoading, isError, navigate }) => {
  const header = useTranslatedObject('header');
  const cart = header.cart || {};

  const cartItems = cartData?.items || [];
  const cartItemLabel = cartItems.length === 1 ? cart.item_singular : cart.item_plural;

  const handleProductCardClick = (item) => {
    navigate(item?.storefrontUrl);
  };

  const handleViewCart = () => {
    navigate(`${CONFIG.LEGACY_APP_URL}/checkout/cart`);
  };

  if (isLoading) {
    return (
        <div className='flex justify-center items-center'>
          <SdfBusyIndicator size="md" />
        </div>
    );
  }

  return (
    <Box>
      <CartTooltipTitleBox>
        <CartTooltipTitle>{cart.summary}</CartTooltipTitle>
      </CartTooltipTitleBox>
      {cartItems && cartItems.length > 0 ? (
        <React.Fragment>
          <Box>
            {cartItems.map((item) => (
              <CartItem
                key={item.id}
                item={item}
                onClick={() => handleProductCardClick(item)}
                header={header}
                cart={cart}
              />
            ))}
          </Box>
          <CartItemButton emphasis="primary" variant="contained" onClick={handleViewCart}>
            {cart.view} ({cartItems.length} {cartItemLabel})
          </CartItemButton>
        </React.Fragment>
      ) : (
        <CartEmptyText>{cart.empty}</CartEmptyText>
      )}
    </Box>
  );
};

CartTooltipContent.propTypes = {
  cartData: PropTypes.shape({
    items: PropTypes.array
  }),
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  navigate: PropTypes.func
};

export default CartTooltipContent;